import { render, staticRenderFns } from "./DownloadSidebar.vue?vue&type=template&id=ccc24a0a"
import script from "./DownloadSidebar.vue?vue&type=script&lang=js"
export * from "./DownloadSidebar.vue?vue&type=script&lang=js"
import style0 from "./DownloadSidebar.vue?vue&type=style&index=0&id=ccc24a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports